import { Divider, Grid, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useMemo } from "react";
import { IMaterialTypeWiseCount } from "../api/types";
import EmptyTable from "components/third-party/EmptyTable";
import StyledDataGrid from "components/@extended/StyledDataGrid";
import { GetMaterialTypeWiseCount } from "../api/hooks";

const MaterialTypeGrid = () => {
  const { data: getQuery } = GetMaterialTypeWiseCount();

  const columns: GridColDef<IMaterialTypeWiseCount>[] = useMemo(
    () => [
      {
        field: "materialTypeName",
        headerName: "Material Type",
        flex: 2,
      },
      {
        field: "materialCount",
        headerName: "Material",
        flex: 1,
        headerAlign: "right",
        align: "right",
        renderCell: (params) => {
          return (
            <>
              {params.value !== null ? (
                <>{params.value.toLocaleString("en-IN")}</>
              ) : (
                "-"
              )}
            </>
          );
        },
      },
      {
        field: "accCount",
        headerName: "Accessions",
        flex: 1,
        headerAlign: "right",
        align: "right",
        renderCell: (params) => {
          return (
            <>
              {params.value !== null ? (
                <>{params.value.toLocaleString("en-IN")}</>
              ) : (
                "-"
              )}
            </>
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <Typography variant="h3" component={"h3"} marginBlockEnd={2}>
        Material Type Wise Count
        <Divider sx={{ my: 1 }} />
      </Typography>
      <Divider />
      <Grid sx={{ height: 400, width: "100%", padding: "0px" }}>
        <StyledDataGrid
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "wrap",
              fontWeight: 600,
              lineHeight: "normal",
              fontSize: "13px",
            },
            "& .MuiDataGrid-cell": {
              whiteSpace: "wrap",
              alignContent: "center",
              fontSize: 14,
            },
          }}
          columns={columns}
          rows={getQuery?.apiData?.data}
          getRowId={(row) => row.materialTypeID}
          density="compact"
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 100 },
            },
          }}
          slots={{
            noRowsOverlay: EmptyTable,
          }}
          pageSizeOptions={[10, 25, 50, 100]}
        />
      </Grid>
    </>
  );
};

export default MaterialTypeGrid;
